<ion-item [color]="color" [ngClass]="{ 'disabled': disabled }" lines="none">
    <ion-icon slot="start" name="search-outline"></ion-icon>
    <upp-kb-input uppDataid="search-input" 
        [placeholder]="placeholder" 
        [(ngModel)]="value"
        [kiosk]="kiosk"
        [readonly]="disabled"  
        (Changed)="value = $event"
    ></upp-kb-input>
    <ion-icon *ngIf="value" uppDataid="search-clear" slot="end" name="arrow-back-circle-outline" (click)="OnClear()"></ion-icon>
</ion-item>